import React from "react";
import { ActuateButton } from "../../../common/ActuateButton";
import { NavigateFunction } from "react-router-dom";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const AddCameraButton = ({
  navigate,
  setNoAutoAddCamerasDialogOpen,
  siteInfo,
}: {
  navigate: NavigateFunction;
  setNoAutoAddCamerasDialogOpen: Dispatcher<boolean>;
  siteInfo?: any;
}) => {
  localStorage.setItem("clickedFromSiteAboutPage", "true");
  return (
    <div>
      <ActuateButton
        onClick={() => {
          localStorage.setItem("firstCameraAdded", "true");
          localStorage.setItem("copyValues", "true");
          localStorage.setItem("addAdditionalCamera", "true");
          localStorage.setItem("clickedFromSiteAboutPage", "true");
          localStorage.setItem("navigatedFromSitesAboutPage", "true");
          // Route on the site's own auto_add (reliable), matching the populated
          // CamerasTable — not the stale localStorage.autoAdd, which is only set
          // during onboarding and misroutes non-auto-add sites (e.g. RTSP /
          // ONVIF-over-WireGuard) to the NVR auto-add page.
          const isAutoAdd = siteInfo
            ? Boolean(siteInfo.auto_add)
            : localStorage.autoAdd !== "false";
          if (isAutoAdd) {
            navigate("/sites/autoaddcamera");
          } else {
            navigate("/sites/addcamera");
          }
        }}
        text="Add Camera"
        disabled={false}
      />
    </div>
  );
};
